import EmblaCarousel from "embla-carousel";
import ClassNames from "embla-carousel-class-names";
import gameData from "@/data/datesGame.js";
import generateToken from "@/utils/generateToken.js";

export default function (element, data) {
  const stepScreens = element.querySelectorAll(".step-screen");
  const nextButtons = element.querySelectorAll("[data-to-step]");
  const answers = [1, 1, 1];

  stepScreens.forEach((screen) => {
    const step = screen.dataset.step;
    const viewport = screen.querySelector(".embla__viewport");
    const prevButton = screen.querySelector(".embla__prev");
    const nextButton = screen.querySelector(".embla__next");

    const emblaApi = EmblaCarousel(
      viewport,
      {
        loop: true,
        align: "center",
        duration: 35,
        //dragFree: true,
      },
      [ClassNames()],
    );

    prevButton.addEventListener("click", emblaApi.scrollPrev, false);
    nextButton.addEventListener("click", emblaApi.scrollNext, false);

    emblaApi.on("select", function (a, b, c) {
      answers[step - 1] = emblaApi.selectedScrollSnap() + 1;
    });
  });

  nextButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const toStep = button.dataset.toStep;
      element.querySelector(".screen.visible").classList.remove("visible");
      element
        .querySelector(".screen.step-screen.step" + toStep)
        .classList.add("visible");
      
      window.document.body.classList.add("started");
    });
  });

  element
    .querySelector(".result-button")
    .addEventListener("click", function () {
      const result = calcResult(answers);
      const token = generateToken(result);

      window.location.search = "?result=" + token;
    });
}

function calcResult(answers) {
  return gameData?.get(answers[0])?.get(answers[1])?.get(answers[2]) || 1;
}
